import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";

export default function Services({ detailed = false }) {
  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-24 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">Our Services</p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight tracking-tight">
            End-to-end HR & workforce solutions
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            From sourcing the right talent to managing payroll and compliance — we operate as an
            extension of your HR function, with measurable outcomes and full transparency.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.slug}
                id={detailed ? s.slug : undefined}
                data-testid={`service-card-${s.slug}`}
                className="group relative bg-white border border-slate-200 rounded-2xl p-7 lg:p-8 hover:border-primary/40 hover:-translate-y-1 hover:shadow-xl shadow-sm transition-all duration-300 ease-out"
              >
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6 text-primary group-hover:text-white" strokeWidth={1.6} />
                </div>
                <h3 className="font-heading font-bold text-lg sm:text-xl text-slate-900 leading-snug">{s.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.short}</p>

                {detailed && (
                  <>
                    <p className="mt-4 text-sm text-slate-600 leading-relaxed">{s.description}</p>
                    <ul className="mt-5 flex flex-wrap gap-2">
                      {s.bullets.map((b) => (
                        <li key={b} className="text-xs font-medium px-2.5 py-1 rounded-md bg-slate-100 text-slate-700 border border-slate-200">
                          {b}
                        </li>
                      ))}
                    </ul>
                    {s.benefits && (
                      <div className="mt-5">
                        <p className="text-xs font-bold uppercase tracking-[0.15em] text-primary mb-2">Key Benefits</p>
                        <ul className="text-sm text-slate-600 space-y-1.5">
                          {s.benefits.map((b) => <li key={b}>• {b}</li>)}
                        </ul>
                      </div>
                    )}
                    {s.compliance && (
                      <div className="mt-5 flex flex-wrap gap-2">
                        {s.compliance.map((c) => (
                          <span key={c} className="text-[11px] font-semibold px-2 py-1 rounded bg-primary/10 text-primary uppercase tracking-wider">{c}</span>
                        ))}
                      </div>
                    )}
                  </>
                )}

                <Link
                  to="/contact"
                  data-testid={`service-cta-${s.slug}`}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-primary-hover transition-colors"
                >
                  Request a proposal
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </article>
            );
          })}
        </div>

        {!detailed && (
          <div className="mt-12 text-center reveal">
            <Link
              to="/services"
              data-testid="services-view-all"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-primary transition-colors"
            >
              Explore all services
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
